import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { GetNameChoose } from "../../funcUtils";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";
import swal from "sweetalert";

function HistoryBet() {
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [history, setHistory] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    function formatDate(m) {
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
            .then((res) => {
                setHistory(res.data.data);
            })
            .catch((err) => function () {});
            
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    const XSMN = [
        "Bạc Liêu", "Vũng Tàu", "Tiền Giang", "Kiên Giang", "Đà Lạt",
        "Bình Phước", "Bình Dương", "An Giang", "Bình Thuận", "Cà Mau",
        "Cần Thơ", "Hậu Giang", "Đồng Tháp", "Tây Ninh", "Vĩnh Long",
        "Trà Vinh", "Sóc Trăng", "Long An", "TP. HCM", "Đồng Nai", "Bến Tre"
    ];
    
    const XSMT = [
        "Đà Nẵng", "Thừa T. Huế", "Quảng Trị", "Phú Yên", "Quảng Bình",
        "Quảng Nam", "Quảng Ngãi", "Ninh Thuận", "Kon Tum", "Khánh Hòa",
        "Gia Lai", "Bình Định", "Đắk Lắk", "Đắk Nông"
    ];

    const checkCancel = (item) => {
        const datexs = new Date(item.id_bet);
        const ngayxs = datexs.getDate();
        const thangxs = datexs.getMonth() + 1;
        const namxs = datexs.getFullYear();
        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
        const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();

        if (item.sanh === "XSMB" && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1800) {
            return false;
        } else if (XSMT.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1700) {
            return false;
        } else if (XSMN.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1600) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />
            
            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .history-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. THÔNG TIN USER (GIỐNG PROFILE)                  */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. DANH SÁCH THẺ LỊCH SỬ                           */
                /* ================================================== */
                .history-content {
                    padding: 0 15px;
                }
                .history-card {
                    background: #fff;
                    border-radius: 8px;
                    padding: 15px;
                    margin-bottom: 12px;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
                    cursor: pointer;
                    position: relative;
                }
                .history-card:active {
                    background: #fafafa;
                }
                .h-top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;
                    border-bottom: 1px solid #f0f0f0;
                    padding-bottom: 8px;
                }
                .h-type {
                    font-weight: bold;
                    font-size: 15px;
                    color: #333;
                }
                .h-status {
                    font-size: 12px;
                    font-weight: bold;
                    padding: 4px 8px;
                    border-radius: 4px;
                }
                .status-pending { background: #fff3cd; color: #ff9800; }
                .status-win { background: #e8f5e9; color: #4caf50; }
                .status-lose { background: #ffebee; color: #f44336; }
                .status-cancel { background: #f5f5f5; color: #9e9e9e; }

                .h-mid {
                    font-size: 13px;
                    color: #555;
                    margin-bottom: 8px;
                    line-height: 1.5;
                }

                .h-bot {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                }
                .h-money {
                    font-size: 16px;
                    font-weight: bold;
                    color: #b71c1c; 
                }
                .h-date {
                    font-size: 12px;
                    color: #999;
                }

                .btn-cancel-bet {
                    background: #d32f2f;
                    color: #fff;
                    border: none;
                    padding: 5px 10px;
                    border-radius: 4px;
                    font-size: 11px;
                    font-weight: bold;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                }
                
                .empty-history {
                    text-align: center;
                    color: #888;
                    margin-top: 50px;
                    font-size: 14px;
                }

                /* ================================================== */
                /* 4. MODAL CHI TIẾT CƯỢC                             */
                /* ================================================== */
                .custom-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6);
                    z-index: 9999999;
                    display: flex; align-items: center; justify-content: center;
                }
                .custom-modal-content {
                    background: #fff;
                    width: 90%;
                    max-width: 400px;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.3);
                    animation: slideUp 0.3s ease-out;
                }
                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                .custom-modal-header {
                    background: #b71c1c;
                    color: #fff;
                    padding: 15px;
                    font-size: 16px;
                    font-weight: bold;
                    text-align: center;
                    text-transform: uppercase;
                }
                .custom-modal-body {
                    padding: 15px 20px;
                }
                .custom-modal-row {
                    display: flex;
                    justify-content: space-between;
                    padding: 10px 0;
                    border-bottom: 1px dashed #eee;
                    font-size: 14px;
                }
                .custom-modal-row:last-child { border-bottom: none; }
                .custom-modal-row span:first-child { color: #666; }
                .custom-modal-row span:last-child { font-weight: bold; color: #333; text-align: right; max-width: 60%; word-wrap: break-word; }
                .custom-modal-footer {
                    padding: 15px 20px 20px 20px;
                }
                .btn-close-modal {
                    background: #555;
                    color: #fff;
                    border: none;
                    padding: 12px;
                    border-radius: 6px;
                    font-weight: bold;
                    cursor: pointer;
                    width: 100%;
                    font-size: 15px;
                }
            `}</style>

            <div className="history-wrapper">

                {/* 2. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                    <h1 className="page-title-h1">Lịch sử trò chơi</h1>
                </div>

                {/* 3. NỘI DUNG LỊCH SỬ */}
                <div className="history-content">
                    {history && history.length > 0 ? (
                        history.map((item, index) => {
                            let statusClass = "status-cancel";
                            let statusText = "Đã hủy";
                            
                            if (item?.status_bet === "Pending") {
                                statusClass = "status-pending";
                                statusText = "Chờ xổ";
                            } else if (item?.status_bet === "Win") {
                                statusClass = "status-win";
                                statusText = "Thắng";
                            } else if (item?.status_bet === "Lose") {
                                statusClass = "status-lose";
                                statusText = "Thua";
                            }

                            return (
                                <div 
                                    className="history-card" 
                                    key={index}
                                    onClick={() => {
                                        setLs(item);
                                        setShow(true);
                                    }}
                                >
                                    <div className="h-top">
                                        <div className="h-type">{item?.sanh === "XSMB" ? "Miền Bắc" : item?.sanh}</div>
                                        <div className={`h-status ${statusClass}`}>
                                            {statusText}
                                        </div>
                                    </div>
                                    
                                    <div className="h-mid">
                                        <div>Phiên cược: <b>{item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}</b></div>
                                        <div>Cược: <b>{GetNameChoose(item?.state, item?.type, item?.sanh) ? GetNameChoose(item?.state, item?.type, item?.sanh) : "Chọn " + item?.state}</b></div>
                                    </div>
                                    
                                    <div className="h-bot">
                                        <div>
                                            {/* ĐÃ SỬA: Chia 1000 và thêm chữ Điểm */}
                                            <div className="h-money">{Math.floor((item?.money || 0) / 1000).toLocaleString("vi-VN")} Điểm</div>
                                            <div className="h-date">{formatDate(new Date(item?.createdAt))}</div>
                                        </div>

                                        {/* NÚT HỦY CƯỢC */}
                                        {item?.status_bet === "Pending" && (
                                            <>
                                                {(item?.sanh === "XSMB" || XSMN.includes(item?.sanh) || XSMT.includes(item?.sanh)) && (
                                                    <>
                                                        {checkCancel(item) && (
                                                            <button
                                                                className="btn-cancel-bet"
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); // Ngăn không mở Modal khi bấm Hủy
                                                                    e.preventDefault();
                                                                    e.target.style.display = "none";
                                                                    const currentDate = new Date();
                                                                    const day = currentDate.getDate();
                                                                    const month = currentDate.getMonth() + 1;
                                                                    const year = currentDate.getFullYear();
                                                                    const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
                                                                    const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();
                                                                    
                                                                    if (item.sanh === "XSMB" && Number(currentDate.getHours() + "" + minute) >= 1800 && Number(currentDate.getHours() + "" + minute) < 1915) {
                                                                        swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                        e.target.style.display = "inline-block";
                                                                        return false;
                                                                    } else if (XSMT.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1700 && Number(currentDate.getHours() + "" + minute) < 1815) {
                                                                        swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                        e.target.style.display = "inline-block";
                                                                        return false;
                                                                    } else if (XSMN.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1600 && Number(currentDate.getHours() + "" + minute) < 1715) {
                                                                        swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                        e.target.style.display = "inline-block";
                                                                        return false;
                                                                    }

                                                                    axios
                                                                        .patch(`${process.env.REACT_APP_API_URL}/history/cancel`, {
                                                                            id: item?._id,
                                                                            userId: profile?._id,
                                                                            money: item?.money
                                                                        })
                                                                        .then((res) => {
                                                                            setShow(false);
                                                                            swal("Hủy cược thành công", "", "success").then(() => {
                                                                                axios
                                                                                    .get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
                                                                                    .then((res) => { setHistory(res.data.data); })
                                                                                    .catch((err) => {});
                                                                            });
                                                                        })
                                                                        .catch((err) => {
                                                                            setShow(false);
                                                                            swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                                                                            e.target.style.display = "inline-block";
                                                                        });
                                                                }}
                                                            >
                                                                &times; Hủy cược
                                                            </button>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="empty-history">
                            Chưa có dữ liệu lịch sử trò chơi.
                        </div>
                    )}
                </div>
            </div>
            
            <Footer profile={profile} />

            {/* 4. MODAL CHI TIẾT CƯỢC */}
            {isShow && ls && ls?.status_bet !== "Pending" && (
                <div className="custom-modal-overlay" onClick={() => setShow(false)}>
                    <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="custom-modal-header">
                            Chi tiết cược
                        </div>
                        <div className="custom-modal-body">
                            {ls?.id_bet?.id_bet || ls?.id_bet ? (
                                <>
                                    <div className="custom-modal-row">
                                        <span>Trò chơi</span>
                                        <span>{ls?.sanh}</span>
                                    </div>
                                    <div className="custom-modal-row">
                                        <span>Phiên</span>
                                        <span>{ls?.id_bet?.id_bet ? ls?.id_bet?.id_bet : ls?.id_bet ? ls?.id_bet : "Không xác định"}</span>
                                    </div>
                                    <div className="custom-modal-row">
                                        <span>Thời gian</span>
                                        <span>{formatDate(new Date(ls?.createdAt))}</span>
                                    </div>
                                    <div className="custom-modal-row">
                                        <span>Đặt cược</span>
                                        <span>{GetNameChoose(ls?.state, ls?.type, ls?.sanh) ? GetNameChoose(ls?.state, ls?.type, ls?.sanh) : "Chọn " + ls?.state}</span>
                                    </div>
                                    
                                    {/* ĐÃ SỬA: Chia 1000 và thêm chữ Điểm */}
                                    <div className="custom-modal-row">
                                        <span>Tổng Cược</span>
                                        <span style={{ color: "#b71c1c" }}>{Math.floor((ls?.money || 0) / 1000).toLocaleString("vi-VN")} Điểm</span>
                                    </div>
                                    <div className="custom-modal-row">
                                        <span>Tổng thắng</span>
                                        <span style={{ color: "#4caf50" }}>{Math.floor((ls?.moneythang || 0) / 1000).toLocaleString("vi-VN")} Điểm</span>
                                    </div>
                                </>
                            ) : null}
                        </div>
                        <div className="custom-modal-footer">
                            <button className="btn-close-modal" onClick={() => setShow(false)}>
                                ĐÓNG
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </AnimatedPage>
    );
}

export default HistoryBet;